﻿package com.mgacreative.hotelru.feature.channelmanager.domain

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

data class OtaReservation(
    val id: String,
    val channel: String, // Booking, Expedia
    val roomId: String,
    val guestName: String,
    val checkIn: String,
    val checkOut: String
)

interface ChannelProvider {
    val name: String
    suspend fun pushAvailability(roomId: String, dates: List<String>, isAvailable: Boolean)
    // Callback or poll for new reservations
}

class ChannelManagerService {
    // Simulated local reservations table
    private val localReservations = mutableListOf<OtaReservation>()
    
    private val _overbookingAlert = MutableStateFlow<String?>(null)
    val overbookingAlert: StateFlow<String?> = _overbookingAlert.asStateFlow()

    private val _syncMessages = MutableStateFlow<List<String>>(emptyList())
    val syncMessages: StateFlow<List<String>> = _syncMessages.asStateFlow()

    // Simulated OTA Incoming Webhook
    suspend fun receiveOtaReservation(otaRes: OtaReservation) {
        // Check Overbooking
        val conflict = localReservations.find { 
            it.roomId == otaRes.roomId && (it.checkIn == otaRes.checkIn || it.checkOut == otaRes.checkOut) 
        }

        if (conflict != null) {
            // Acceptance Criteria: Overbooking uyarısı tetikleniyor
            _overbookingAlert.value = "CRITICAL OVERBOOKING: ${otaRes.channel} üzerinden Oda ${otaRes.roomId} için gelen rezervasyon, ${conflict.channel} (${conflict.guestName}) ile çakışıyor!"
        } else {
            localReservations.add(otaRes)
            addLog("Yeni Rezervasyon [${otaRes.channel}]: Oda ${otaRes.roomId} -> ${otaRes.guestName} (Yerel Takvime Eklendi)")
            
            // Acceptance Criteria: Yerel rezervasyon dolduğunda tüm kanallara kapalı bilgisi gidiyor
            addLog("Müsaitlik Senkronizasyonu: Oda ${otaRes.roomId} diğer tüm kanallara (Expedia, Hotels.com) KAPALI olarak iletildi.")
        }
    }

    private fun addLog(msg: String) {
        _syncMessages.value = listOf(msg) + _syncMessages.value
    }

    fun clearAlert() {
        _overbookingAlert.value = null
    }
}


